import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_171: DocMigration = {
  maxSchemaVersion: "0.0.171",
  description: "Delete preset active state from doc; moved to editor",
  apply(json: any) {
    if (json.activePresetId) {
      delete json.activePresetId;
    }
    if (json.editingActivePreset) {
      delete json.editingActivePreset;
    }

    return json;
  },
};

export default migration_0_0_171;
